<template>
    <div :class="`ion-padding ${props.centered && 'ion-text-center'} modal-content ion-flex-1`">
      <div>
        <div class="title">
          <div v-if="props.type" class="logo-container">
            <ion-icon :icon="icons[props.type]" class="logo"></ion-icon>
          </div>
          <h2 v-if="title">{{ title }}</h2>
          <slot v-else name="title"></slot>
        </div>

        <div class="content">
          <div v-if="props.type" class="spacer" />
          <slot name="content"></slot>
        </div>
      </div>

      <div class="buttons">
        <slot name="buttons"></slot>
      </div>
    </div>
</template>

<script setup lang="ts">
import { IonIcon, IonModal } from '@ionic/vue';
import {warningOutline} from "ionicons/icons";

const icons = {
  'warning': warningOutline,
}

interface UserProps {
  show: boolean
  title?: string
  centered?: boolean
  type?: keyof typeof icons
}

const props = withDefaults(
    defineProps<UserProps>(),
    {
      show: false,
      centered: false
    }
)
</script>

<style scoped>
.modal-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem
}

.logo-container, .spacer {
  width: 85px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.spacer {
  align-items: flex-start;
}

.content {
  display: flex;
}

.content * {
  margin: unset;
}

.title, .content {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.title .logo {
  font-size: 4rem;
}

.title h2 {
  text-align: start;
}

.buttons {
  display: flex;
  gap: .8rem;
  justify-content: center;
  align-self: flex-end;
}

@media (max-width: 576px) {
  .logo-container {
    height: 75px;
    margin-bottom: 1rem;
  }

  .title h2 {
    margin-top: unset;
  }

  .title, .content  {
    flex-direction: column;
    gap: unset;
  }

  .spacer {
    width: 0;
    height: 0;
  }
}
</style>